import React, { useEffect, useState } from 'react';
import axios from '../util/axiosConfig'
import InvContext from './InvContext';
import { invContextType, IDataItem, PoDocProps, purchaseGrpProps, RoleInterface, VendorDocProps } from '../types/inv';

interface ProviderProps {
    children: React.ReactNode;
}

const InvProvider: React.FC<ProviderProps> = ({ children }) => {

    const [plants, setPlants] = useState<IDataItem[]>([]);
    const [poDocType, setPoDocType] = useState<PoDocProps[]>([]);
    const [purchaseGroup, setPurchaseGroup] = useState<purchaseGrpProps[]>([]);
    const [roles, setRoles] = useState<RoleInterface[]>([]);
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
    const [vendorDoc, setVendorDoc] = useState<VendorDocProps[]>([]);

    useEffect(() => {
        const fetchPlantsData = async () => {
            try {
                const response = await axios.get('/plant/get-all-plants');
                const plants = response?.data?.data;
                setPlants(plants)
            } catch (error) {
                console.error('Failed to fetch Plants', error);
            }
        };

        fetchPlantsData();
    }, []);

    useEffect(() => {
        const fetchPoDocType = async () => {
            try {
                const response = await axios.get('/po-document-type/get-all-po-document-type');
                const poDocType = response?.data?.data;
                setPoDocType(poDocType)
            } catch (error) {
                console.error('Failed to fetch PO Doc Types', error);
            }
        };
        fetchPoDocType();
    }, []);

    useEffect(() => {
        const fetchPurchaseGroup = async () => {
            try {
                const response = await axios.get('/purchase-group/get-all-purchase-group');
                const purchaseGroup = response?.data?.data;
                setPurchaseGroup(purchaseGroup);
            } catch (error) {
                console.error('Failed to fetch Purchase Groups', error);
            }
        };
        fetchPurchaseGroup();
    }, []);

    useEffect(() => {
        const fetchAllRoles = async () => {
            try {
                const response = await axios.get('/roles/get-all-roles');
                const roleList = response?.data?.data;
                setRoles(roleList);
            } catch (error) {
                console.error('Failed to fetch Roles', error);
            }
        };
        fetchAllRoles();
    }, []);

    const pmsContextValue: invContextType = {
        plants,
        setPlants,
        poDocType,
        setPoDocType,
        purchaseGroup,
        setPurchaseGroup,
        roles,
        setRoles,
        isAdmin,
        setIsAdmin,
        vendorDoc,
        setVendorDoc
    };

    return <InvContext.Provider value={pmsContextValue}>
        {children}
    </InvContext.Provider>;
};

export default InvProvider;